module.exports = __webpack_public_path__ + "static/media/blumira_login_blue.fe3120a1.png";